import { EnvironmentModel } from './environment.model'

export function env(): EnvironmentModel {
  return {
    stage: 'env-test',
    auth: {
      domain: 'dev-c4be3obj05th0lrq.eu.auth0.com',
      clientId: 'o3b8OICbcp3i5PTtnCytgal9OhMCjPgL',
      authorizationParams: {
        audience: 'https://tst-inko-leistungserbringer-backend.azurewebsites.net/',
        scope: 'openid profile email offline_access',
        redirect_uri: window.location.origin,
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      httpInterceptor: {
        allowedList: ['https://tst-inko-leistungserbringer-backend.azurewebsites.net/api/*'],
      },
    },
    api: {
      leistungserbringerUrl: 'https://tst-inko-leistungserbringer-backend.azurewebsites.net/api',
    },
    selfserviceWebappBaseUrl: 'https://versorgung-tst.saniup.de',
  }
}
